import React from 'react';

export const Input = React.forwardRef(({ className = '', type = 'text', ...props }, ref) => {
  return (
    <input
      type={type}
      ref={ref}
      className={`
        flex h-10 w-full rounded-md border border-slate-200 bg-white px-3 py-2 text-sm 
        ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium 
        placeholder:text-slate-500 focus-visible:outline-none focus-visible:ring-2 
        focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:cursor-not-allowed 
        disabled:opacity-50
        ${className}
      `}
      {...props}
    />
  );
});

Input.displayName = 'Input';
